module.exports = __webpack_public_path__ + "img/arrow.769259b5.svg";